module.exports = __webpack_public_path__ + "img/suit-07.1126e927.png";